import Login from './components/Login.vue'
import Auth from './components/Auth.vue'
import RoleLink from './components/RoleLink.vue'
// import epsHome from './components/dashboard/Home.vue';
//const FileUpload = () => import('./TryNError/FileUpload');
//const Sample = () => import('./TryNError/sample');
const updatePassword = () =>
    import('./components/dashboard/UpdatePassword');
const Home = () =>
    import('./components/dashboard/Home.vue');
const erpcheck = () =>
    import('./components/dashboard/erpcheck.vue');
const ForgotPassword = () =>
    import('./components/ForgotPassword.vue');
const AdminMaster = () =>
    import('./components/Admin/AdminMaster');
//Admin Master
const ExamConfiguration = () =>
    import('./components/Admin/AdminMaster/ExamConfiguration');
const Role = () =>
    import('./components/Admin/AdminMaster/Role');
const InstructorType = () =>
    import('./components/Admin/AdminMaster/InstructorType');
const QuestionType = () =>
    import('./components/Admin/AdminMaster/QuestionType');
const OmrSet = () =>
    import('./components/Admin/AdminMaster/OMRSet');
const ProctoringStatus = () =>
    import('./components/Admin/AdminMaster/ProctoringStatus');
const ProctoringType = () =>
    import('./components/Admin/AdminMaster/ProctoringType');
const CommunicationMode = () =>
    import('./components/Admin/AdminMaster/CommunicationMode');
const CourseAuthorityOperation = () =>
    import('./components/Admin/AdminMaster/CourseAuthorityOperation');
const StudentAnsweredStatus = () =>
    import('./components/Admin/AdminMaster/StudentAnsweredStatus');
const Year = () =>
    import('./components/Admin/AdminMaster/Year');
const AcademicYear = () =>
    import('./components/Admin/AdminMaster/AcademicYear');
const Semester = () =>
    import('./components/Admin/AdminMaster/Semester');
const ExamStatus = () =>
    import('./components/Admin/AdminMaster/ExamStatus');
const ExamType = () =>
    import('./components/Admin/AdminMaster/ExamType');
const ExamEnviornmentType = () =>
    import('./components/Admin/AdminMaster/ExamEnviornmentType');
const StudentAttribute = () =>
    import('./components/Admin/AdminMaster/StudentAttribute');
const SubjectTool = () =>
    import('./components/Admin/AdminMaster/SubjectTool');
const LowerSecurityModeOptions = () =>
    import('./components/Admin/AdminMaster/LowerSecurityModeOptions');
const DifficultyLevel = () =>
    import('./components/Admin/AdminMaster/DifficultyLevel');
const Language = () =>
    import('./components/Admin/AdminMaster/Language');
const Pattern = () =>
    import('./components/Admin/AdminMaster/Pattern');
const RegistrationType = () =>
    import('./components/Admin/AdminMaster/RegistrationType');
const Unit = () =>
    import('./components/Admin/AdminMaster/Unit');
const CourseAuthorityLevels = () =>
    import('./components/Admin/AdminMaster/CourseAuthorityLevels');
const ExamSlot = () =>
    import('./components/Admin/AdminMaster/ExamSlot');
const Division = () =>
    import('./components/Admin/AdminMaster/Division');
//end admin master
const AdminImport = () =>
    import('./components/Admin/AdminImport');
const AddUser = () =>
    import('./components/Admin/AddUser');
const CreateExam = () =>
    import('./components/COE/CreateExam');
const learnerblockresult = () =>
    import('./components/COE/learnerblockresult')
//QP template
const Template = () =>
    import('./components/COE/Template/Template');
const DefineTemplate = () =>
    import('./components/COE/Template/DefineTemplate');
const OfferTemplate = () =>
    import('./components/COE/Template/OfferTemplate');
const CreateTemplate = () =>
    import('./components/COE/Template/CreateTemplate');
//ends
const CourseAuthorityAppointment = () =>
    import('./components/COE/CourseAuthorityAppointment/CourseAuthorityAppointment');
const SubjectAuthorityAppointmentImport = () =>
    import('./components/COE/CourseAuthorityAppointment/SubjectAuthorityAppointmentImport');
const AllCourseAuthority = () =>
    import('./components/COE/CourseAuthorityAppointment/AllCourseAuthority');
const SubjectAuthorityAppointment = () =>
    import('./components/COE/CourseAuthorityAppointment/SubjectAuthorityAppointment');
const QuestionBankStatus = () =>
    import('./components/COE/QuestionBankStatus');
const ExamQuestionBankStatus = () =>
    import('./components/COE/ExamQuestionBankStatus');
const ExamResult = () =>
    import('./components/COE/ExamResult');
const StudentQuestionViewCoe = () =>
    import('./components/COE/StudentQuestionViewCoe');
const ExamResultNew = () =>
    import('./components/COE/ExamResultNew');
const ExamResultLatest = () =>
    import('./components/COE/ExamResultLatest');
const ExamResultCorrection = () =>
    import('./components/COE/ExamResultCorrection');
const QuestionDetails = () =>
    import('./components/COE/QuestionDetails');
const QuestionPaperTemplate = () =>
    import('./components/COE/QuestionPaperTemplate');
const ExamLiveDashboard = () =>
    import('./components/COE/ExamLiveDashboard');
const ExamTypeQuestionTypeMapping = () =>
    import('./components/COE/ExamTypeQuestionTypeMapping');
const CopyQue = () =>
    import('./components/COE/CopyQue');
const QuestionPaperTemplateStatus = () =>
    import('./components/COE/QuestionPaperTemplateStatus');
const StudExamQueData = () =>
    import('./components/COE/StudExamQueData');
const StudExamQuestionData = () =>
    import('./components/COE/StudExamQuestionData');
const StudentExamInvalidQuestionExcel = () =>
    import('./components/COE/StudentExamInvalidQuestionExcel');
const QueAllocationData = () =>
    import('./components/COE/QueAllocationData');
const ResultDifferenceData = () =>
    import('./components/COE/ResultDifferenceData');
const QuestionBankCoe = () =>
    import('./components/COE/QuestionBankCoe');
const QpTempalte = () =>
    import('./components/PaperSetter/QpTempalte');
const ApplyTemplate = () =>
    import('./components/PaperSetter/ApplyTemplate');
//by vrushali paper setter Q.bank
const QuestionBankTemplate = () =>
    import('./components/PaperSetter/QuestionBankTemplate/QuestionBankTemplate');
const QuestionBank = () =>
    import('./components/PaperSetter/QuestionBank');
const AddQuestionBank = () =>
    import('./components/PaperSetter/AddQuestionBank');
const EditQuestionBank = () =>
    import('./components/PaperSetter/EditQuestionBank')
const EditSubQuestionBank = () =>
    import('./components/PaperSetter/EditSubQuestionBank')
const AddQuestionToBank = () =>
    import('./components/PaperSetter/QuestionBankTemplate/AddQuestionToBank');
const AddSubQuestionToBank = () =>
    import('./components/PaperSetter/QuestionBankTemplate/AddSubQuestionToBank');
const StudentQuestionView = () =>
    import('./components/PaperSetter/StudentQuestionView');
const AdminUserTypeMaster = () =>
    import('./components/Admin/AdminMaster/AdminUserTypeMaster');
const AdminInstructorTypeMaster = () =>
    import('./components/Admin/AdminMaster/AdminInstructorTypeMaster');
const InstructorQuestionView = () =>
    import('./components/PaperSetter/InstructorQuestionView');
// Alankar code
const StudentAnswerAnalysis = () =>
    import('./components/PaperSetter/StudentAnswerAnalysis');
const StudentAnswerAnalysisNew = () =>
    import('./components/PaperSetter/StudentAnswerAnalysisNew');
const ChengeProctorDuty = () =>
    import('./components/COE/ChengeProctorDuty');
//Alankar code end
//SuperAdmin
const LoginSuperAdmin = () =>
    import('./components/SuperAdmin/LoginSuperAdmin');
const SuperAdminHome = () =>
    import('./components/SuperAdmin/SuperAdminHome');
//masters
const MasterMenu = () =>
    import('./components/SuperAdmin/Master/MasterMenu');
const AddTenant = () =>
    import('./components/SuperAdmin/AddTenant');
const AddOrganization = () =>
    import('./components/SuperAdmin/AddOrganization');
const PushMaster = () =>
    import('./components/SuperAdmin/PushMaster');
const PushRoleLinks = () =>
    import('./components/SuperAdmin/PushRoleLinks');
const LoginDetails = () =>
    import('./components/SuperAdmin/LoginDetails');
const UserTypeSuperMaster = () =>
    import('./components/SuperAdmin/Master/UserTypeSuperMaster');
const ExamConfigurationSuperMaster = () =>
    import('./components/SuperAdmin/Master/ExamConfigurationSuperMaster');
const StudentAnsweredStatusSuperMaster = () =>
    import('./components/SuperAdmin/Master/StudentAnsweredStatusSuperMaster');
const LowerSecurityModeOptionsSuperMaster = () =>
    import('./components/SuperAdmin/Master/LowerSecurityModeOptionsSuperMaster');
const StudentAttributeSuperMaster = () =>
    import('./components/SuperAdmin/Master/StudentAttributeSuperMaster');
const SubjectToolSuperMaster = () =>
    import('./components/SuperAdmin/Master/SubjectToolSuperMaster');
const QuestionTypeSuperMaster = () =>
    import('./components/SuperAdmin/Master/QuestionTypeSuperMaster');
const ProctoringTypeSuperMaster = () =>
    import('./components/SuperAdmin/Master/ProctoringTypeSuperMaster');
const ProctoringStatusSuperMaster = () =>
    import('./components/SuperAdmin/Master/ProctoringStatusSuperMaster');
const CommunicationModeSuperMaster = () =>
    import('./components/SuperAdmin/Master/CommunicationModeSuperMaster');
const LanguageSuperMaster = () =>
    import('./components/SuperAdmin/Master/LanguageSuperMaster');
const ExamTypeSuperMaster = () =>
    import('./components/SuperAdmin/Master/ExamTypeSuperMaster');
const ExamEnviornmentTypeSuperMaster = () =>
    import('./components/SuperAdmin/Master/ExamEnviornmentTypeSuperMaster');
const CourseAuthorityOperationSuperMaster = () =>
    import('./components/SuperAdmin/Master/CourseAuthorityOperationSuperMaster');
const ExamStatusSuperMaster = () =>
    import('./components/SuperAdmin/Master/ExamStatusSuperMaster');
const LinkSuperMaster = () =>
    import('./components/SuperAdmin/Master/LinkSuperMaster');
const RoleSuperMaster = () =>
    import('./components/SuperAdmin/Master/RoleSuperMaster');

//ends
const AdminProgramTypeMaster = () =>
    import('./components/Admin/AdminMaster/AdminProgramTypeMaster');
const AdminProgramMaster = () =>
    import('./components/Admin/AdminMaster/AdminProgramMaster');
const AdminDepartmentMaster = () =>
    import('./components/Admin/AdminMaster/AdminDepartmentMaster');
const AdminAddRoleMaster = () =>
    import('./components/Admin/AdminMaster/AdminAddRoleMaster');
const AddMasterLink = () =>
    import('./components/Admin/AdminMaster/AddMasterLink');
const AdminAddUserMaster = () =>
    import('./components/Admin/AdminMaster/AdminAddUserMaster');
const AdminAddRoleToUser = () =>
    import('./components/Admin/AdminMaster/AdminAddRoleToUser');
const AdminAddRoleLink = () =>
    import('./components/Admin/AdminMaster/AddRoleLinks');
const AdminResetUserPassword = () =>
    import('./components/Admin/AdminMaster/AdminResetUserPassword');
//Student
const StartExam = () =>
    import('./components/Student/StartExam');
const ViewAnswerSheet = () =>
    import('./components/Student/ViewAnswerSheet');
const CapturePic = () =>
    import('./components/Student/CapturePic');
const StudExam = () =>
    import('./components/Student/StudExam');
const Chat = () =>
    import('./components/Student/StudChat');
const StudLogtable = () =>
    import('./components/Student/StudLogtable');
const StudISAtable = () =>
    import('./components/Student/StudISAtable');
const Calculator = () =>
    import('./components/Student/StudCalculator');
const EndExam = () =>
    import('./components/Student/EndExam');

//Test
const sample = () =>
    import('./components/sample.vue');
const File = () =>
    import('./components/TestCode/File.vue');
const ExamResultUnit = () =>
    import('./components/COE/ExamResultUnit');
const InvalidQuestionStudents = () =>
    import('./components/COE/InvalidQuestionStudents');
const Math = () =>
    import('./components/TestCode/Math.vue');
const SubjectiveEvaluation = () =>
    import('./components/PaperChecker/SubjectiveEvalution.vue');
const SubjectiveChecking = () =>
    import('./components/PaperChecker/SubjectiveChecking.vue');
//import
const StudentImport = () =>
    import('./components/Admin/AdminImport/StudentImport');
const InstructorImport = () =>
    import('./components/Admin/AdminImport/InstructorImport');
const SubjectImport = () =>
    import('./components/Admin/AdminImport/SubjectImport');
const SubjectRegImport = () =>
    import('./components/Admin/AdminImport/SubjectRegImport');
const CourseInstructorImport = () =>
    import('./components/Admin/AdminImport/CourseInstructoreImport');
const ExamTimeTableImport = () =>
    import('./components/Admin/AdminImport/ExamTimeTableImport');
const ExamTimeTableImportNew = () =>
    import('./components/Admin/AdminImport/ExamTimeTableImportNew');
const ExamTT_import_new = () =>
    import('./components/Admin/AdminImport/ExamTT_import_new');
const UploadPhoto = () =>
    import('./components/COE/UploadPhoto')
const AddProctor = () =>
    import('./components/COE/AddProctor')
const GetStudentQuestionDetails = () =>
    import('./components/COE/GetStudentQuestionDetails')
const ProctorDutyAppointment = () =>
    import('./components/COE/Proctor-appointment/ProctorDutyAppointment')
const ProctorDutyAppointmentNew = () =>
    import('./components/COE/Proctor-appointment/ProctorDutyAppointmentNew')
const AssignProctor = () =>
    import('./components/COE/Proctor-appointment/AssignProctor')
const StudentProctorStatus = () =>
    import('./components/COE/Proctor-appointment/StudentProctorStatus')
const AddExamInstruction = () =>
    import('./components/Admin/AdminMaster/AddExamInstruction')
//mayur
const QuestionBankVerification = () =>
    import('./components/ScrutinyCommitee/QuestionBankVerification')
//vrushali exam live dashbord
const ExamLiveDashbord = () =>
    import('./components/COE/ExamLiveDashbord')

const ExamLiveDashbordDivisionWise = () =>
    import('./components/COE/ExamLiveDashbordDivisionWise')

const LiveDashbord = () =>
    import('./components/COE/LiveDashboard')
const COEAllocation = () =>
    import('./components/COE/COEAllocation')
const COECourseWiseAllocation = () =>
    import('./components/COE/CourseWiseQueAllocation')
const ImportDepartment = () =>
    import('./components/Admin/AdminImport/ImportDepartment')
const ImportProgram = () =>
    import('./components/Admin/AdminImport/ImportProgram')
//testing 
const ImageCapture = () =>
    import('./components/Student/ImageCapture')
const PhotoCapture = () =>
    import('./components/Student/PhotoCapture')
const WeiredSound = () =>
    import('./components/Student/WeiredSound')
const ProctorMonitoring = () =>
    import('./components/COE/ProctorMonitoring')
//Proctor
const ProctorDuty = () =>
    import('./components/Proctor/ProctorDuty')
//Supervisor
const SupervisorDuty = () =>
    import('./components/Proctor/SupervisorDuty')
const SupervisorLiveDashboard = () =>
    import('./components/Proctor/SupervisorLiveDashboard')
const ProctorLiveDashboard = () =>
    import('./components/Proctor/ProctorLiveDashboard')
const ProctorChat = () =>
    import('./components/Proctor/ProctorChat')
const ShowResult = () =>
    import('./components/Student/ShowResult');
const ShowResultMCA = () =>
    import('./components/Student/ShowResultMCA');
const StudentAttendanceReport = () =>
    import('./components/COE/StudentAttendanceReport')
const attendanceReport = () =>
    import('./components/COE/attendanceReport')
const InstQuestionView = () =>
    import('./components/PaperSetter/InstQuestionView')
const InstructorSubQuestionView = () =>
    import('./components/PaperSetter/InstructorSubQuestionView')
const ProctorDashboardforCOE = () =>
    import('./components/COE/COEProctorDashboard')
const SubjectwiseDashboard = () =>
    import('./components/COE/SubjectwiseDashboard')
const SubjectwiseDashboardNew = () =>
    import('./components/COE/SubjectwiseDashboardNew')
const StudentResult = () =>
    import('./components/Student/StudentResult');
const StudentChat = () =>
    import('./components/Student/StudentChat');
const ManageResults = () =>
    import('./components/COE/ManageResults');
const LearnerReexam = () =>
    import('./components/COE/LearnerReexam');
const ProctorLearnerMapping = () =>
    import('./components/COE/ProctorLearnerMapping');
const QuestionBankTemplateImport = () =>
    import('./components/PaperSetter/QuestionBankTemplateImport/QuestionBankTemplateImport');

const QuestionBankImport = () =>
    import('./components/PaperSetter/QuestionBankImport');

const AddQuestionToBankImport = () =>
    import('./components/PaperSetter/QuestionBankTemplateImport/AddQuestionToBankImport');

const ExamLiveDashbordNull = () =>
    import('./components/COE/ExamLiveDashbordNull')

const LiveDashbordNull = () =>
    import('./components/COE/LiveDashboardNull')

//Quiz Dashboard
const Quiz = () =>
    import('./components/QuizDashboard/Quiz');
const QuizDashboard = () =>
    import('./components/QuizDashboard/QuizDashboard');
const QuizMonitoring = () =>
    import('./components/QuizDashboard/QuizMonitoring');
const QuizQuestionPaper = () =>
    import('./components/QuizDashboard/QuizQuestionPaper');
const QuizResponse = () =>
    import('./components/QuizDashboard/QuizResponse');
const QuizStudentResponse = () =>
    import('./components/QuizDashboard/QuizStudentResponse');
const QuizLiveDashboard = () =>
    import('./components/QuizDashboard/QuizLiveDashboard');
const OverallQuizDashboard = () =>
    import('./components/QuizDashboard/OverallQuizDashboard');
const OverallQuizLiveDashboard = () =>
    import('./components/QuizDashboard/OverallQuizLiveDashboard');
const AllocationStatusReport = () =>
    import('./components/QuizDashboard/AllocationStatusReport');
const ExportMarks = () =>
    import('./components/QuizDashboard/ExportMarks');
const AllocationStudentForQuiz = () =>
    import('./components/QuizDashboard/AllocationStudentForQuiz');
const AddSingleStudentForQuiz = () =>
    import('./components/QuizDashboard/AddSingleStudentForQuiz');
const ExportMarksBatchwise = () =>
    import('./components/QuizDashboard/ExportMarksBatchwise');
//by vrushali
const Evaluation = () =>
    import('./components/Evaluation/Evaluation');
export const routes = [{
    path: '/weiredsound',
    name: 'weiredsound',
    component: WeiredSound,
},
{
    path: '/photo',
    name: 'photo',
    component: PhotoCapture,
},
{
    path: '/sample',
    name: 'sample',
    component: sample,
},
{
    path: '/test/file',
    name: 'test-file',
    component: File,
},
{
    path: '/test/math',
    name: 'test-math',
    component: Math,
},
//student exam
{
    path: '/student/stud-exam',
    name: 'stud-exam',
    component: StudExam,
},
{
    path: '/student/capture-pic',
    name: 'capture-pic',
    component: CapturePic
},
{
    path: '/student/chat',
    name: 'chat',
    component: Chat,
},
{
    path: '/student/studLogtable',
    name: 'studLogtable',
    component: StudLogtable,
},
{
    path: '/student/StudISAtable',
    name: 'StudISAtable',
    component: StudISAtable,
},
{
    path: '/student/stud-calculator',
    name: 'Calculator',
    component: Calculator,
},
{
    path: '/student/end-exam',
    name: 'stud-end-exam',
    component: EndExam,
},
{
    path: '/student/show-result',
    name: 'show-result',
    component: ShowResult,
},

{
    path: '/student/show-resultMCA',
    name: 'show-resultMCA',
    component: ShowResultMCA,
},
//Super Admin
{
    path: '/eps-admin',
    name: 'eps-admin',
    component: LoginSuperAdmin,
},
{
    path: '/eps-admin/home',
    name: 'eps-admin-home',
    component: SuperAdminHome,
    children: [{
        path: '/eps-admin/master',
        name: 'eps-admin-master-menu',
        component: MasterMenu,
    },
    {
        path: '/eps-admin/add-tenant',
        name: 'eps-admin-add-tenant',
        component: AddTenant,
    },
    {
        path: '/eps-admin/add-organization',
        name: 'eps-admin-add-organization',
        component: AddOrganization,
    },
    {
        path: '/eps-admin/push-supermaster',
        name: 'eps-admin-push-supermaster',
        component: PushMaster,
    },
    {
        path: '/eps-admin/login-details',
        name: 'eps-admin-login-details',
        component: LoginDetails,
    },
    {
        path: '/eps-admin/push-role-links',
        name: 'eps-admin-push-role-links',
        component: PushRoleLinks,
    },
    {
        path: '/eps-admin/user-type',
        name: 'eps-admin-master-user-type',
        component: UserTypeSuperMaster,
    },
    {
        path: '/eps-admin/exam-config',
        name: 'eps-admin-master-exam-config',
        component: ExamConfigurationSuperMaster,
    },
    {
        path: '/eps-admin/student-answered-status',
        name: 'eps-admin-master-student-answer-status',
        component: StudentAnsweredStatusSuperMaster,
    },
    {
        path: '/eps-admin/lower-security-mode-options',
        name: 'eps-admin-master-lower-security-mode-options',
        component: LowerSecurityModeOptionsSuperMaster,
    },
    {
        path: '/eps-admin/student-attributes',
        name: 'eps-admin-master-student-attribute',
        component: StudentAttributeSuperMaster,
    },
    {
        path: '/eps-admin/subject-tool',
        name: 'eps-admin-master-subject-tool',
        component: SubjectToolSuperMaster,
    },
    {
        path: '/eps-admin/question-type',
        name: 'eps-admin-master-question-type',
        component: QuestionTypeSuperMaster,
    },
    {
        path: '/eps-admin/proctoring-type',
        name: 'eps-admin-master-proctoring-type',
        component: ProctoringTypeSuperMaster,
    },
    {
        path: '/eps-admin/proctoring-status',
        name: 'eps-admin-master-proctoring-status',
        component: ProctoringStatusSuperMaster,
    },
    {
        path: '/eps-admin/communication-mode',
        name: 'eps-admin-master-communication-mode',
        component: CommunicationModeSuperMaster,
    },
    {
        path: '/eps-admin/master',
        name: 'eps-admin-master-menu',
        component: MasterMenu,
    },
    {
        path: '/eps-admin/user-type',
        name: 'eps-admin-master-user-type',
        component: UserTypeSuperMaster,
    },
    {
        path: '/eps-admin/exam-type',
        name: 'eps-admin-master-exam-type',
        component: ExamTypeSuperMaster,
    },
    {
        path: '/eps-admin/language',
        name: 'eps-admin-master-language',
        component: LanguageSuperMaster,
    },
    {
        path: '/eps-admin/exam-enviornment-type',
        name: 'eps-admin-master-exam-enviornment-type',
        component: ExamEnviornmentTypeSuperMaster,
    },
    {
        path: '/eps-admin/course-authority-operation',
        name: 'eps-admin-master-course-authority-operation',
        component: CourseAuthorityOperationSuperMaster,
    },
    {
        path: '/eps-admin/exam-status',
        name: 'eps-admin-master-exam-status',
        component: ExamStatusSuperMaster,
    },
    {
        path: '/eps-admin/exam-config',
        name: 'eps-admin-master-exam-config',
        component: ExamConfigurationSuperMaster,
    },
    {
        path: '/eps-admin/link',
        name: 'eps-admin-master-link',
        component: LinkSuperMaster,
    },
    {
        path: '/eps-admin/role',
        name: 'eps-admin-role',
        component: RoleSuperMaster,
    },
    ]
},

//ends
{
    path: '/home',
    component: Home
},
{
    path: '/erp_check',
    component: erpcheck
},
{
    path: '/',
    component: Login
},
{
    path: '/global-auth',
    name: 'global-auth',
    component: Auth
},
{
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
},
{
    path: '/update-password',
    component: updatePassword
},
{
    path: '/student/student-result',
    name: 'student-result',
    component: StudentResult,
},
{
    path: '/student/student-chat',
    name: 'student-chat',
    component: StudentChat,
},
{
    path: '/role-links',
    name: 'role-links',
    component: RoleLink,
    props: true,
    children: [{
        path: '/admin-master',
        name: 'admin-master',
        component: AdminMaster,
    },
    {
        path: '/uploadphoto',
        name: 'uploadphoto',
        component: UploadPhoto,
    },
    {
        path: '/add-user',
        name: 'add-user',
        component: AddUser,
    },
    //master
    {
        path: '/admin-master/admin-user-type',
        name: 'admin-master-user-type',
        component: AdminUserTypeMaster
    },
    {
        path: '/admin-master/admin-instructor-type',
        name: 'admin-master-instructor-type',
        component: AdminInstructorTypeMaster
    },
    {
        path: '/admin-master/admin-program-type',
        name: 'admin-master-program-type',
        component: AdminProgramTypeMaster
    },
    {
        path: '/admin-master/admin-program',
        name: 'admin-master-program',
        component: AdminProgramMaster
    },
    {
        path: '/admin-master/admin-AddRole',
        name: 'admin-master-addrole',
        component: AdminAddRoleMaster
    },
    {
        path: '/add-masterlink',
        name: 'add-master-link',
        component: AddMasterLink
    },
    {
        path: '/admin-master/admin-AddRoleLink',
        name: 'admin-master-addrolelink',
        component: AdminAddRoleLink
    },
    {
        path: '/admin-master/admin-AddUser',
        name: 'admin-master-adduser',
        component: AdminAddUserMaster
    },
    {
        path: '/admin-master/admin-Resetpassword',
        name: 'admin-master-resetpassword',
        component: AdminResetUserPassword
    },
    {
        path: '/admin-master/admin-AddRoleToUser',
        name: 'admin-master-addroletouser',
        component: AdminAddRoleToUser
    },
    {
        path: '/admin-master/admin-department-type',
        name: 'admin-master-department',
        component: AdminDepartmentMaster
    },
    {
        path: '/admin-master/exam-config',
        name: 'admin-master-exam-config',
        component: ExamConfiguration,
    },
    {
        path: '/admin-master/role',
        name: 'admin-master-role',
        component: Role,
    },
    {
        path: '/admin-master/instructor-type',
        name: 'admin-master-instructor-type',
        component: InstructorType,
    },
    {
        path: '/admin-master/question-type',
        name: 'admin-master-question-type',
        component: QuestionType,
    },
    {
        path: '/admin-master/Year',
        name: 'admin-master-year',
        component: Year,
    },

    {
        path: '/admin-master/AcademicYear',
        name: 'admin-master-academicyear',
        component: AcademicYear,
    },
    {
        path: '/assign-proctor',
        name: 'assign-proctor',
        component: AssignProctor

    },
    {
        path: '/student-proctor-status',
        name: 'student-proctor-status',
        component: StudentProctorStatus

    },
    {
        path: '/admin-master/AddExamInstruction',
        name: 'admin-master-examinstruction',
        component: AddExamInstruction,
    },
    {
        path: '/admin-master/Semester',
        name: 'admin-master-semester',
        component: Semester,
    },
    {
        path: '/admin-master/ExamStatus',
        name: 'admin-master-examStatus',
        component: ExamStatus,
    },
    {
        path: '/admin-master/ExamType',
        name: 'admin-master-examType',
        component: ExamType,
    },
    {
        path: '/admin-master/ExamEnviornmentType',
        name: 'admin-master-examEnvironmentType',
        component: ExamEnviornmentType,
    },
    {
        path: '/admin-master/StudentAttribute',
        name: 'admin-master-studentAttribute',
        component: StudentAttribute,
    },
    {
        path: '/admin-master/SubjectTool',
        name: 'admin-master-subjectTool',
        component: SubjectTool,
    },
    {
        path: '/admin-master/Omrset',
        name: 'admin-master-omrset',
        component: OmrSet,
    },
    {
        path: '/admin-master/proctoringstatus',
        name: 'admin-master-proctoringstatus',
        component: ProctoringStatus,
    },
    {
        path: '/admin-master/proctoringtype',
        name: 'admin-master-proctoringtype',
        component: ProctoringType,
    },
    {
        path: '/admin-master/communication-mode',
        name: 'admin-master-communication-mode',
        component: CommunicationMode,
    },
    {
        path: '/admin-master/course-authority-operation',
        name: 'admin-master-course-authority-operation',
        component: CourseAuthorityOperation,
    },
    {
        path: '/admin-master/student-answered-status',
        name: 'admin-master-student-answered-status',
        component: StudentAnsweredStatus,
    },
    {
        path: '/admin-master/lower-seucrity-mode',
        name: 'admin-master-lower-seucrity-mode',
        component: LowerSecurityModeOptions,
    },
    {
        path: '/admin-master/difficulty-level',
        name: 'admin-master-difficulty-level',
        component: DifficultyLevel,
    },
    {
        path: '/admin-master/language',
        name: 'admin-master-language',
        component: Language,
    },
    {
        path: '/admin-master/pattern',
        name: 'admin-master-pattern',
        component: Pattern,
    },
    {
        path: '/admin-master/registration-type',
        name: 'admin-master-registration-type',
        component: RegistrationType,
    },
    {
        path: '/admin-master/unit',
        name: 'admin-master-unit',
        component: Unit,
    },
    {
        path: '/admin-master/course-authority-levels',
        name: 'admin-master-course-authority-levels',
        component: CourseAuthorityLevels,
    }, //
    {
        path: '/admin-master/exam-slot',
        name: 'admin-master-exam-slot',
        component: ExamSlot,
    },

    {
        path: '/admin-master/division',
        name: 'admin-master-division',
        component: Division,
    },
    //ends
    {
        path: '/admin-import',
        name: 'admin-import',
        component: AdminImport,
    },
    {
        path: '/exam-result-unit-wise',
        name: 'exam-result-unit-wise',
        component: ExamResultUnit,
    },
    {
        path: '/invalid-question-students',
        name: 'invalid-question-students',
        component: InvalidQuestionStudents,
    },
    {
        path: '/coe-create-exam',
        name: 'coe-create-exam',
        component: CreateExam,
    },
    {
        path: '/coe/template',
        name: 'coe-template',
        component: Template,
        children: [{
            path: '/coe/create-template',
            name: 'coe-create-template',
            component: CreateTemplate
        },
        {
            path: '/coe/define-template',
            name: 'coe-define-template',
            component: DefineTemplate
        },
        {
            path: '/coe/offer-template',
            name: 'coe-offer-template',
            component: OfferTemplate
        },
        ]
    },
    {
        path: '/coe/courseAuthorityAppointment',
        name: 'coe-course-authority-ppointment',
        component: CourseAuthorityAppointment,
        children: [{
            path: '/coe/subject-authority-appointment',
            name: 'coe-subject-authority-appointment',
            component: SubjectAuthorityAppointment
        },
        {
            path: '/coe/subject-authority-appointment-import',
            name: 'coe-subject-authority-appointment-import',
            component: SubjectAuthorityAppointmentImport
        },
        {
            path: '/coe/All-Course-Authority',
            name: 'All-Course-Authority',
            component: AllCourseAuthority
        },
        ]
    },
    {
        path: '/papersetter/questionBankTemplate',
        name: 'papersetter-question-bank-template',
        component: QuestionBankTemplate,
        children: [{
            path: '/papersetter/add-question-to-bank',
            name: 'papersetter-add-question-to-bank',
            component: AddQuestionToBank
        },
        {
            path: '/papersetter/add-sub-question-to-bank',
            name: 'papersetter-add-sub-question-to-bank',
            component: AddSubQuestionToBank
        },
        {
            path: '/coe/subject-authority-appointment-import',
            name: 'coe-subject-authority-appointment-import',
            component: SubjectAuthorityAppointmentImport
        },
        ]

    },
    {
        path: '/papersetter/questionBankTemplateImport',
        name: 'papersetter-question-bank-template-import',
        component: QuestionBankTemplateImport,
        children: [{
            path: '/papersetter/add-question-to-bank-import',
            name: 'papersetter-add-question-to-bank-import',
            component: AddQuestionToBankImport
        },

        ]

    },
    {
        path: '/subjective-evalution',
        name: 'subjective-evalution',
        component: SubjectiveEvaluation
    },
    {
        path: '/subjective-checking',
        name: 'subjective-checking',
        component: SubjectiveChecking
    },
    {
        path: '/papersetter/evaluation',
        name: 'papersetter-evaluation',
        component: Evaluation

    },
    {
        path: '/papersetter/edit-question-to-bank',
        name: 'papersetter-edit-question-to-bank',
        component: EditQuestionBank
    },
    {
        path: '/que-Bankcoe',
        name: 'que-Bankcoe',
        component: QuestionBankCoe,
    },
    {
        path: '/stud-que-view-coe',
        name: 'stud-que-view-coe',
        component: StudentQuestionViewCoe,
    },
    {
        path: '/papersetter/edit-sub-question-to-bank',
        name: 'papersetter-edit-sub-question-to-bank',
        component: EditSubQuestionBank
    },
    {
        path: '/coe-exam-result',
        name: 'coe-exam-result',
        component: ExamResult,
    },
    {
        path: '/coe-exam-result-new',
        name: 'coe-exam-result-new',
        component: ExamResultNew,
    },
    {
        path: '/coe-exam-result-latest',
        name: 'coe-exam-result-latest',
        component: ExamResultLatest,
    },
    {
        path: '/coe-exam-result-correction',
        name: 'coe-exam-result-correction',
        component: ExamResultCorrection,
    },
    {
        path: '/question-details',
        name: 'question-details',
        component: QuestionDetails,
    },
    {
        path: '/coe-learner-exam-result-block',
        name: 'coe-learner-exam-result-block',
        component: learnerblockresult
    },
    {
        path: '/instructor-question-view',
        name: 'instructor-question-view',
        component: InstructorQuestionView,
    },
    {
        path: '/student-answer-analysis',
        name: 'student-answer-analysis',
        component: StudentAnswerAnalysisNew,
    },
    // {
    //     path: '/student-answer-analysis-new',
    //     name: 'student-answer-analysis-new',
    //     component: StudentAnswerAnalysisNew,
    // },
    {
        path: '/chenge-proctor-duty',
        name: 'chenge-proctor-duty',
        component: ChengeProctorDuty,
    },
    {
        path: '/inst-question-view',
        name: 'inst-question-view',
        component: InstQuestionView
    },
    {
        path: '/inst-sub-question-view',
        name: 'inst-sub-question-view',
        component: InstructorSubQuestionView
    },
    {
        path: '/coe-question-bank-status',
        name: 'coe-question-bank-status',
        component: QuestionBankStatus,

    },
    {
        path: '/coe-exam-question-bank-status',
        name: 'coe-exam-question-bank-status',
        component: ExamQuestionBankStatus,

    },
    {
        path: '/coe-question-paper-template',
        name: 'coe-question-paper-template',
        component: QuestionPaperTemplate,
    },
    {
        path: '/coe-exam-live-dashboard',
        name: 'coe-exam-live-dashboard',
        component: ExamLiveDashboard,

    },
    {
        path: '/proctor-monitoring',
        name: 'proctor-monitoring',
        component: ProctorMonitoring
    },
    {
        path: '/coe-proctor-dashboard',
        name: 'coe-proctor-dashboard',
        component: ProctorDashboardforCOE
    },
    {
        path: '/subjectwise-dashboard',
        name: 'subjectwise-dashboard',
        component: SubjectwiseDashboard
    },
    {
        path: '/subjectwise-dashboardnew',
        name: 'subjectwise-dashboardnew',
        component: SubjectwiseDashboardNew
    },
    {
        path: '/manage-results',
        name: 'manage-results',
        component: ManageResults
    },
    {
        path: '/proctor-learner-mapping',
        name: 'proctor-learner-mapping',
        component: ProctorLearnerMapping
    },
    {
        path: '/learner-reexam',
        name: 'learner-reexam',
        component: LearnerReexam
    },
    {
        path: '/qp-template',
        name: 'qp-template',
        component: QpTempalte,
        children: [{
            path: '/ps-apply-template',
            name: 'ps-apply-template',
            component: ApplyTemplate,
        },
        {
            path: '/ps-create-template',
            name: 'ps-create-template',
            component: CreateTemplate
        },
        {
            path: '/ps-define-template',
            name: 'ps-define-template',
            component: DefineTemplate
        },
        ]
    },

    {
        path: '/exam-type-question-type-mapping',
        name: 'exam-type-question-type-mapping',
        component: ExamTypeQuestionTypeMapping,
    },
    //by vrushali
    {
        path: '/que-Bank',
        name: 'que-Bank',
        component: QuestionBank,
    },
    {
        path: '/add-que-Bank',
        name: 'add-que-Bank',
        component: AddQuestionBank,
    },
    {
        path: '/add-question-Bank',
        name: 'add-question-Bank',
        component: AddQuestionToBank,
    },
    {
        path: '/que-Bank-import',
        name: 'que-Bank-import',
        component: QuestionBankImport,
    },
    {
        path: '/stud-que-view',
        name: 'stud-que-view',
        component: StudentQuestionView,
    },

    //Student
    {
        path: 'student/start-exam',
        name: 'stud-start-exam',
        component: StartExam,
        props: true,
    },
    {
        path: 'student/view-answer-sheet',
        name: 'view-answer-sheet',
        component: ViewAnswerSheet,
        props: true,
    },

    //Import
    {
        path: '/admin-import-student',
        name: 'admin-import-student',
        component: StudentImport,
    },
    {
        path: '/admin-import-instructor',
        name: 'admin-import-instructor',
        component: InstructorImport,
    },
    {
        path: '/admin-import-subject',
        name: 'admin-import-subject',
        component: SubjectImport,
    },
    {
        path: '/add-proctor',
        name: 'add-proctor',
        component: AddProctor

    },
    {
        path: '/get-student-question-details',
        name: 'get-student-question-details',
        component: GetStudentQuestionDetails

    },
    {
        path: '/copy-que',
        name: 'copy-que',
        component: CopyQue

    },
    {
        path: '/question-paper-template-status',
        name: 'question-paper-template-status',
        component: QuestionPaperTemplateStatus

    },
    {
        path: '/Stud-ExamQueData',
        name: 'Stud-ExamQueData',
        component: StudExamQueData

    },
    {
        path: '/Stud-ExamQuestionData',
        name: 'Stud-ExamQuestionData',
        component: StudExamQuestionData
    },
    {
        path: '/student-exam-invalid-que-data',
        name: 'student-exam-invalid-que-data',
        component: StudentExamInvalidQuestionExcel
    },
    {
        path: '/que-allocation-status',
        name: 'que-allocation-status',
        component: QueAllocationData

    },
    {
        path: '/result-difference-data',
        name: 'result-difference-data',
        component: ResultDifferenceData
    },
    {
        path: '/proctor-duties',
        name: 'proctor-duties',
        component: ProctorDutyAppointment

    },
    {
        path: '/proctor-duties-new',
        name: 'proctor-duties-new',
        component: ProctorDutyAppointmentNew

    },
    {
        path: '/admin-import-subject_reg',
        name: 'admin-import-subject_reg',
        component: SubjectRegImport,
    },
    {
        path: '/admin-import-course-instructor',
        name: 'admin-import-course-instructor',
        component: CourseInstructorImport,
    },
    {
        path: '/exam-t-t-new',
        name: 'exam-t-t-new',
        component: ExamTT_import_new,
    },
    {
        path: '/admin-import-exam_time_table',
        name: 'admin-import-exam_time_table',
        component: ExamTimeTableImport,
    },
    {
        path: '/admin-import-exam_time_table_new',
        name: 'admin-import-exam_time_table_new',
        component: ExamTimeTableImportNew,
    },
    {
        path: '/sc-question_bank_verification',
        name: 'sc-question_bank_verification',
        component: QuestionBankVerification,
    },
    {
        path: '/coe-exam-live-dashbord',
        name: 'coe-exam-live-dashbord',
        component: ExamLiveDashbord
    },
    {
        path: '/coe-divisionwise-exam-live-dashbord',
        name: 'coe-divisionwise-exam-live-dashbord',
        component: ExamLiveDashbordDivisionWise
    },
    {
        path: '/coe-live-dashbord',
        name: 'coe-live-dashbord',
        component: LiveDashbord
    },
    {
        path: '/coe-exam-live-dashbord-null',
        name: 'coe-exam-live-dashbord-null',
        component: ExamLiveDashbordNull
    },

    {
        path: '/coe-live-dashbord-null',
        name: 'coe-live-dashbord-null',
        component: LiveDashbordNull
    },
    {
        path: '/coe-ques-allocation',
        name: 'coe-ques-allocation',
        component: COEAllocation
    },
    {
        path: '/coe-course-ques-allocation',
        name: 'coe-course-ques-allocation',
        component: COECourseWiseAllocation
    },
    {
        path: '/admin-import-department',
        name: 'admin-import-department',
        component: ImportDepartment
    },
    {
        path: '/admin-import-program',
        name: 'admin-import-program',
        component: ImportProgram
    },
    //Proctor
    {
        path: '/proctor/proctor-duty',
        name: 'proctor-duty',
        component: ProctorDuty
    },
    {
        path: '/proctor/proctor-live-dashboard',
        name: 'proctor-live-dashboard',
        component: ProctorLiveDashboard
    },
    //Supervisor
    {
        path: '/proctor/proctor-duty-supervisor',
        name: 'proctor-duty-supervisor',
        component: SupervisorDuty
    },
    //Supervisor dashboard
    {
        path: '/proctor/supervisor-live-dashboard',
        name: 'supervisor-live-dashboard',
        component: SupervisorLiveDashboard
    },
    {
        path: '/proctor/proctor-chat',
        name: 'proctor-chat',
        component: ProctorChat
    },
    {
        path: '/student-attendance-report',
        name: 'student-attendance-report',
        component: StudentAttendanceReport
    },
    {
        path: '/attendance-report',
        name: 'attendance-report',
        component: attendanceReport
    },

    //Quiz Dashboard
    {
        path: '/quiz',
        name: 'quiz',
        component: Quiz,
    },
    {
        path: '/quiz-dashboard',
        name: 'quiz-dashboard',
        component: QuizDashboard,
    },
    {
        path: '/quiz-monitoring',
        name: 'quiz-monitoring',
        component: QuizMonitoring,
    },
    {
        path: '/quiz-question-paper',
        name: 'quiz-question-paper',
        component: QuizQuestionPaper,
    },
    {
        path: '/quiz-response',
        name: 'quiz-response',
        component: QuizResponse,
    },
    {
        path: '/quiz-student-response',
        name: 'quiz-student-response',
        component: QuizStudentResponse,
    },
    {
        path: '/quiz-live-dashboard',
        name: 'quiz-live-dashboard',
        component: QuizLiveDashboard,
    },
    {
        path: '/overall-quiz-dashboard',
        name: 'overall-quiz-dashboard',
        component: OverallQuizDashboard,
    },
    {
        path: '/overall-quiz-live-dashboard',
        name: 'overall-quiz-live-dashboard',
        component: OverallQuizLiveDashboard,
    },
    {
        path: '/allocation-status-report',
        name: 'allocation-status-report',
        component: AllocationStatusReport,
    },
    {
        path: '/export-marks',
        name: 'export-marks',
        component: ExportMarks,
    },
    {
        path: '/allocation-student-for-quiz',
        name: 'allocation-student-for-quiz',
        component: AllocationStudentForQuiz,
    },
    {
        path: '/add-single-student-for-quiz',
        name: 'add-single-student-for-quiz',
        component: AddSingleStudentForQuiz,
    },
    {
        path: '/export-marks-batchwise',
        name: 'export-marks-batchwise',
        component: ExportMarksBatchwise,

    },
    ]
},


];